<template>
    <div
        v-if="model.invoice"
        class="my-auto"
        :class="container">
        <!-- <deposit-attachment
            v-if="value.invoice.payment_method === 'deposito'"
            v-model="model"
            :invoiceId="model.invoice.id" /> -->
        <div :class="card">
            <h1 class="px-3 py-2 mb-0"><i class="mdi mdi-credit-card mr-3"></i>{{$t('billing.invoice.invoice')}}</h1>
            <table id="cart" class="table table-hover table-condensed">
                <thead class="thead-light">
                    <tr>
                        <th>{{ showInvoiceTypeName }}</th>
                        <th colspan="2"></th>
                        <th>{{$t('cart.price')}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="model.invoice.value">
                        <td data-th="Product">
                            <p class="mb-0">{{formatPlans(model.invoice.plans)}}</p>
                        </td>
                        <td colspan="2"></td>
                        <td data-th="Price" class="budget">
                            {{formatValue(model.invoice.value, model.invoice.currency)}}
                        </td>
                    </tr>
                    <tr v-if="model.invoice.interest && model.invoice.days > 0">
                        <td data-th="Product">
                            <h4 class="mb-0">{{$t('billing.invoice.interest')}} ({{model.invoice.interest*100}}% {{$t('billing.invoice.interest_per_days')}})</h4>
                        </td>
                        <td colspan="2"></td>
                        <td data-th="Price" class="budget">
                            {{formatValue((model.invoice.interest* model.invoice.value)*model.invoice.days, model.invoice.currency)}}
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="flex-container">
                <div>
                    <a href="/app/financial" class="btn btn-warning">{{$t('common.back')}}</a>
                </div>
                <div>
                    <span class="total">
                        <strong>
                            {{$t('billing.invoice.total')}}: {{ formatValue(model.invoice.total, model.invoice.currency) }}
                        </strong>
                    </span>
                    <br>
                    <strong v-show="model.invoice.created_at">
                        {{$t('billing.invoice.created_at')}}: {{ $moment(model.invoice.created_at).format('DD/MM/YYYY')  }}
                    </strong>
                    <br>
                    <strong v-show="model.invoice.due_date">
                        {{$t('billing.invoice.expiry')}}: {{ $moment(model.invoice.due_date).format('DD/MM/YYYY')  }}
                    </strong>
                    <br>
                    <strong>
                        {{$t('billing.invoice.status.title')}}: {{$t(status.status)}}
                    </strong>
                    <br>
                    <strong v-show="model.invoice.due_date_duplicate">
                        {{$t('billing.invoice.expiry_duplicate')}}:
                        {{ $moment(model.invoice.due_date_duplicate).format('DD/MM/YYYY')  }}
                    </strong>
                </div>
                <div>
                    <div>
                        <a
                            v-show="model.invoice.boleto_url"
                            :href="model.invoice.boleto_url"
                            target="_blank"
                            class="btn"
                            :class="[{'disabled':!model.invoice.show_boleto}, model.invoice.show_boleto?'btn-info':'btn-secondary']"
                        >
                            {{$t('billing.invoice.billet.show')}}
                        </a>
                    </div>
                </div>
                <div>
                    <button @click="status.event" :class="status.class" :disabled="status.disabled">{{$t(status.label)}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Currency from '../mixins/currency'
import DepositAttachment from '../components/Common/DepositAttachment'

export default {
    name: 'Invoice',

    props: {
        value: {
            type: Object,
        }
    },

    components: {
        DepositAttachment
    },
    data() {
        return {
            gateway: null,
            model: this.value,
            currency: '',
            upload: null,
        }
    },
    mixins: [
        Currency,
    ],
    watch: {
        currency(newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
                this.$loading.show()
                this.$store.dispatch('CHANGE_CURRENCY', {
                    code: newVal
                })
                window.axios
                    .get(`/api/app/invoices/${this.model.invoice.id}/currency/?code=${newVal}`)
                    .then(res => {
                        this.$loading.close()
                        if (res.data) {
                            this.model.invoice.total = res.data.invoice.total;
                            this.model.invoice.fee = res.data.invoice.fee;
                            this.model.invoice.value = res.data.invoice.value;
                            this.model.invoice.currency = res.data.invoice.currency;
                        }
                    })
                    .catch(err => console.error(err))
                    .finally(() => this.$loading.close());
            }
        },
    },
    computed: {
        container() {
            if (this.$mq === 'sm' || this.$mq === 'md') {
                return 'container-fluid';
            }

            return 'container';
        },
        card() {
            if (this.$mq === 'sm') {
                return '';
            }

            return 'card nch--cart';
        },
        status() {
            const {
                status,
                due_date,
                due_date_duplicate,
            } = this.model.invoice;

            let date = due_date_duplicate ? due_date_duplicate : due_date;
            if (date) {
                date = date.split('-');
                const due = new Date(date[0], date[1] - 1, date[2]);
                const now = new Date();
                due.setHours(0, 0, 0, 0);
                now.setHours(0, 0, 0, 0);

                if (status === 0) {
                    return {
                        status: 'billing.invoice.status.paid',
                        label: 'billing.invoice.payed',
                        class: 'btn btn-dark btn-block',
                        event: () => { },
                        disabled: true,
                    };
                } else if (status === 1) {
                    return {
                        status: 'billing.invoice.status.pending',
                        label: 'billing.invoice.goto_payment',
                        class: 'btn btn-success btn-block',
                        event: this.buyAgain,
                        disabled: false,
                    };
                } else if (status === 3) {
                    return {
                        status: 'billing.invoice.status.processing',
                        label: 'billing.invoice.duplicate.generate',
                        class: 'btn btn-success btn-block',
                        event: this.generateDuplicate,
                        disabled: false,
                    };
                } else if (status === 6) {
                    return {
                        status: 'billing.invoice.status.canceled',
                        label: 'billing.invoice.buy_again',
                        class: 'btn btn-success btn-block',
                        event: this.buyAgain,
                        disabled: false,
                    };
                }
                return {
                    status: 'billing.invoice.status.processing',
                    label: 'billing.invoice.processing',
                    class: 'btn btn-dark btn-block',
                    event: () => { },
                    disabled: true,
                };
            }
        },
        showInvoiceTypeName() {
            if (this.value.invoice.status === 1) {
                return this.value.invoice.invoice_id;
            }
            return this.$t('cart.product');
        }
    },
    methods: {
        buyAgain() {
            window.location.href = `/cart?invoice=${this.model.invoice.invoice_id}`;
        },
        generateDuplicate() {
            this.$loading.show()
            window.axios
                .post(`/api/app/invoices/${this.model.invoice.id}/duplicate`)
                .then(res => {
                    this.$loading.close()
                    this.$notify({
                        type: 'success',
                        message: res.data.data.message
                    })
                    if (res.data) {
                        this.model = res.data.data
                    }
                })
                .catch(err => console.error(err))
                .finally(() => this.$loading.close())
        },
        formatPlans(plans) {
            return plans.map(plan => plan.translation.name).join(', ')
        },
    }

}
</script>

<style scoped>
.list-enter-active,
.list-leave-active {
    transition: all 1s;
}

.list-enter,
.list-leave-to {
    opacity: 0;
    transform: translateX(30px);
}

.nch--table-header {
    background-color: #F6F9FC
}

.nch--cart {
    width: 90%;
    margin: auto;
    margin-top: 40px;
    margin-bottom: 40px
}

.table td,
.table th,
.el-table td,
.el-table th {
    white-space: normal;
}

.table>tbody>tr>td,
.table>tfoot>tr>td {
    vertical-align: middle;
}
.flex-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 20px;
}

@media screen and (max-width: 600px) {
    table#cart tbody td .form-control {
        display: inline !important;
    }

    table#cart thead {
        display: none;
    }

    table#cart tbody td {
        display: block;
        padding: .6rem;
        min-width: 320px;
    }

    table#cart tbody tr td:first-child {
        background: #b4b4b4;
        color: #fff;
        border-radius: 10px
    }

    table#cart tbody td:before {
        content: attr(data-th);
        font-weight: bold;
        display: inline-block;
    }

    table#cart tfoot td {
        display: block;
    }

    table#cart tfoot td .btn {
        display: block;
    }
}

.total {
    font-weight: 900;
    font-size: 1.2em;
}
</style>
